module.exports = __webpack_public_path__ + "img/specialist-absences-hover.8fa0c7e7.svg";